/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';

export type CardSurface = 'list' | 'map-popup' | 'map-carousel';

export const CardSurfaceContext = React.createContext<CardSurface | null>(null);
